"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const libs_polyfills_1 = require("@hotelplan/libs.polyfills");
function useOnFocusOutside(ref, handler, isListening = true) {
    (0, react_1.useEffect)(() => {
        if (!isListening) {
            return;
        }
        const onFocusIn = (event) => {
            // Do nothing if clicking ref's element or descendent elements
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            handler(event);
        };
        document.addEventListener('focusin', onFocusIn, libs_polyfills_1.optionsWithPassive);
        return function cleanupListeners() {
            document.removeEventListener('focusin', onFocusIn);
        };
    }, [ref, handler, isListening]);
}
exports.default = useOnFocusOutside;
//# sourceMappingURL=useOnFocusOutside.js.map